import request from './httpService';

const EMAIL_TEMPLATE_ENDPOINT = '/emailtemplate';

const saveTemplate = (data) => {
  return request({
    method: 'POST',
    url: `${EMAIL_TEMPLATE_ENDPOINT}`,
    data
  });
};

const getTemplates = () => {
  return request({
    method: 'GET',
    url: `${EMAIL_TEMPLATE_ENDPOINT}`
  });
};

const getTemplate = (id) => {
  return request({
    method: 'GET',
    url: `${EMAIL_TEMPLATE_ENDPOINT}/${id}`
  });
};

const updateTemplate = (id, data) => {
  return request({
    method: 'PUT',
    url: `${EMAIL_TEMPLATE_ENDPOINT}/${id}`,
    data
  });
};

const deleteTemplate = (id) => {
  return request({
    method: 'DELETE',
    url: `${EMAIL_TEMPLATE_ENDPOINT}/${id}`
  });
};

const copyDefaultTemplate = (id) => {
  return request({
    method: 'POST',
    url: `${EMAIL_TEMPLATE_ENDPOINT}/${id}/copy-default`
  });
};

const saveConfig = (data) => {
  return request({
    method: 'POST',
    url: `${EMAIL_TEMPLATE_ENDPOINT}/config/save`,
    data
  });
};

const getConfig = () => {
  return request({
    method: 'GET',
    url: `${EMAIL_TEMPLATE_ENDPOINT}/config/get`
  });
};

const getCommunicationTypes = () => {
  return request({
    method: 'GET',
    url: `${EMAIL_TEMPLATE_ENDPOINT}/metadata/communication-types`
  });
};

const getMetadata = () => {
  return request({
    method: 'GET',
    url: `${EMAIL_TEMPLATE_ENDPOINT}/metadata`
  });
};

const getPlaceholders = () => {
  return request({
    method: 'GET',
    url: `${EMAIL_TEMPLATE_ENDPOINT}/metadata/placeholders`
  });
};

const getEditorConfig = () => {
  return request({
    method: 'GET',
    url: `${EMAIL_TEMPLATE_ENDPOINT}/metadata/editor-config`
  });
};

export const EmailTemplateService = {
  saveTemplate,
  getTemplates,
  getTemplate,
  updateTemplate,
  deleteTemplate,
  copyDefaultTemplate,
  saveConfig,
  getConfig,
  getMetadata,
  getCommunicationTypes,
  getPlaceholders,
  getEditorConfig
};